<template>
  <div class="image-viewer" >
    <!-- 缩略图列表 -->
    <div class="thumbnails">
      <img
          :src="images[imgId].thumbnail || images[imgId].src"
          class="thumbnail"
          :class="{active: currentIndex === 1 }"
          @click="openViewer(imgId)"
      />
    </div>
    <!-- 大图查看器（模态框） -->
    <div v-if="isOpen" class="modal" @click.self="closeViewer">
      <div class="modal-content">
        <!-- 上一张按钮 -->
        <button class="nav-btn prev" @click="prevImage">
          <i class="fa fa-chevron-left"></i>
        </button>

        <!-- 当前显示的大图 -->
        <div class="image-container">
          <img :src="currentImage.src" class="main-image" @click.stop />
        </div>

        <!-- 下一张按钮 -->
        <button class="nav-btn next" @click="nextImage">
          <i class="fa fa-chevron-right"></i>
        </button>

        <!-- 关闭按钮 -->
        <button class="close-btn" @click="closeViewer">
          <i class="fa fa-times"></i>
        </button>

        <!-- 图片索引指示器 -->
        <div class="index-indicator">
          {{ currentIndex + 1 }}/{{ images.length }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImageViewer',
  props: {
    images: {
      type: Array,
      required: true,
      default: () => []
    },
    imgId:{
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      isOpen: false,
      currentIndex: 0
    };
  },
  computed: {
    currentImage() {
      return this.images[this.currentIndex] || {};
    }
  },
  methods: {
    // 打开查看器并显示指定索引的图片
    openViewer(index) {
      this.currentIndex = index;
      this.isOpen = true;
      document.body.style.overflow = 'hidden'; // 防止背景滚动
    },
    // 关闭查看器
    closeViewer() {
      this.isOpen = false;
      document.body.style.overflow = ''; // 恢复背景滚动
    },
    // 切换到上一张图片
    prevImage() {
      this.currentIndex =
          this.currentIndex > 0 ? this.currentIndex - 1 : this.images.length - 1;
    },
    // 切换到下一张图片
    nextImage() {
      this.currentIndex =
          this.currentIndex < this.images.length - 1 ? this.currentIndex + 1 : 0;
    },
    // 键盘导航
    handleKeydown(e) {
      if (!this.isOpen) return;

      switch (e.key) {
        case 'Escape':
          this.closeViewer();
          break;
        case 'ArrowLeft':
          this.prevImage();
          break;
        case 'ArrowRight':
          this.nextImage();
          break;
      }
    }
  },
  mounted() {
    window.addEventListener('keydown', this.handleKeydown);
  }
};
</script>

<style scoped>
.image-viewer{
  display: flex;
  justify-content: center;
  align-items: center;
}
.thumbnails {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 0 auto;
}

.thumbnail {
  /* 统一设置宽高，强制所有图片尺寸一致 */
  width: 30vw; /* 设置统一宽度 */
  height: 35vh; /* 设置统一高度 */
  object-fit: contain;
  border-radius: 4px;
  cursor: pointer;
  border: 2px solid transparent;
  transition: all 0.3s;
}

.thumbnail.active,
.thumbnail:hover {
  /*border-color: #4285f4;*/
  /* transform: scale(1.05);*/
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(225, 225, 225, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  animation: fadeIn 0.3s ease-out;
}

.modal-content {
  position: relative;
  max-width: 90%;
  max-height: 90%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.image-container {
  max-width: 100%;
  max-height: 85vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.main-image {
  max-width: 100%;
  max-height: 85vh;
  object-fit: contain;
  animation: scaleIn 0.3s ease-out;
}

.nav-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  border: none;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.3s;
  z-index: 10;
}

.nav-btn:hover {
  background-color: rgba(0, 0, 0, 0.8);
}

.prev {
  left: 20px;
}

.next {
  right: 20px;
}

.close-btn {
  position: absolute;
  top: -40px;
  right: 0;
  background: none;
  border: none;
  color: white;
  font-size: 24px;
  cursor: pointer;
  transition: transform 0.3s;
}

.close-btn:hover {
  transform: rotate(90deg);
}

.index-indicator {
  position: absolute;
  bottom: -30px;
  left: 50%;
  transform: translateX(-50%);
  color: white;
  font-size: 16px;
  background-color: rgba(0, 0, 0, 0.5);
  padding: 4px 12px;
  border-radius: 20px;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes scaleIn {
  from { transform: scale(0.95); opacity: 0; }
  to { transform: scale(1); opacity: 1; }
}
</style>
